import React from "react";
import useStore from "../store/useStore";

const Search = ({ className }) => {
  const setCurrentSearchTerm = useStore((state) => state.setCurrentSearchTerm);
  const currentSearchTerm = useStore((state) => state.currentSearchTerm);
  const translations = useStore((state) => state.translations);

  const handleChange = (event) => {
    setCurrentSearchTerm(event.target.value);
  };

  return (
    <div className={className}>
      <div className="solutions__search">
        <div className="solutions__search-search" />
        <input
          type="search"
          value={currentSearchTerm}
          onChange={handleChange}
          className="solutions__search-field"
          placeholder={translations.search.data}
          data-translate={translations.search.key}
        />
        <button
          className="solutions__search-clean"
          aria-label="Clear"
          onClick={handleChange}
          type="button"
          value=""
        />
      </div>
    </div>
  );
};

export default Search;
